import { SelectAllDto } from '@osos/shared/api';
import { ButtonActionTypeEnum } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace CoreSystemButtonsActions {
  /**
   *
   */

  export class FetchSystemButtons {
    static readonly type = '[SystemButtons] Fetch SystemButtons for end user';
    constructor(
      public entityId: string,
      public viewId?: string,
    ) {}
  }

  export class FetchSystemButtonsStateForEntries {
    static readonly type =
      '[SystemButtons] Fetch SystemButtons state for entries';
    constructor(
      public entityId: string,
      public viewId?: string,
      public entriesIds?: string[],
      public selectAll?: SelectAllDto,
    ) {}
  }

  export class FetchSystemButtonAction {
    static readonly type =
      '[SystemButtons] Fetch SystemButtons Action for end user';
    constructor(
      public buttonId: string,
      public triggerId: string,
      public cached = true,
    ) {}
  }

  export class ExecuteSystemButton {
    static readonly type = '[SystemButtons] Execute SystemButton';
    constructor(
      public payload: {
        buttonId: string;
        mode: ButtonActionTypeEnum;
        source: string | string[];
        overrideValues?: Array<null | { actionId: string; options?: any }>;
        askUserValue?: any;
        selectAll?: SelectAllDto;
        hideLoading?: boolean;
        viewId?: string;
      },
    ) {}
  }

  export class DeleteSystemButton {
    static readonly type = '[SystemButtons] SystemButton';
    constructor(
      public buttonId: string,
      public entityId: string,
    ) {}
  }

  export class FetchSystemButtonJobStatus {
    static readonly type = '[SystemButtons] fetch SystemButton job status';
    constructor(public messageId: string) {}
  }

  export class SubscribeToSystemButtonJobStatus {
    static readonly type =
      '[SystemButtons] start the interval subscription of SystemButton job status';
    constructor(public messageId: string) {}
  }

  export class SetSystemButtonsInformativeLoader {
    static readonly type =
      '[SystemButtons] start or end the informative loader of SystemButton';
    constructor(public isLoading: boolean) {}
  }

  export class ClearSystemButtonActionOptions {
    static readonly type = '[SystemButtons] Clear SystemButton Action Options';
    constructor(public triggerIds: string[]) {}
  }
}
